import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewProgressReportComponent } from './new-progress-report.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxAutocompleteModule, DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextAreaModule } from 'devextreme-angular';



@NgModule({
  declarations: [NewProgressReportComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTextAreaModule,
    DxButtonModule,
    DxAutocompleteModule
  ],
  exports: [NewProgressReportComponent]
})
export class NewProgressReportModule { }
